/**
 * BillingWalletApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MerchantResourceWallet } from '../model/merchantResourceWallet';
import { MerchantResourceWalletMapDto } from '../model/merchantResourceWalletMapDto';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MerchantResourceWalletService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param walletId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantResourceWalletDelete(walletId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMerchantResourceWalletDelete(walletId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMerchantResourceWalletDelete(walletId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMerchantResourceWalletDelete(walletId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (walletId !== undefined && walletId !== null) {
            queryParameters = queryParameters.set('walletId', <any>walletId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/MerchantResourceWallet`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param merchantWalletId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantResourceWalletDetailGet(merchantWalletId?: string, observe?: 'body', reportProgress?: boolean): Observable<MerchantResourceWallet>;
    public apiMerchantResourceWalletDetailGet(merchantWalletId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MerchantResourceWallet>>;
    public apiMerchantResourceWalletDetailGet(merchantWalletId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MerchantResourceWallet>>;
    public apiMerchantResourceWalletDetailGet(merchantWalletId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantWalletId !== undefined && merchantWalletId !== null) {
            queryParameters = queryParameters.set('merchantWalletId', <any>merchantWalletId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MerchantResourceWallet>('get',`${this.basePath}/api/MerchantResourceWallet/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param merchantResourceWalletId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantResourceWalletGet(merchantResourceWalletId?: string, observe?: 'body', reportProgress?: boolean): Observable<MerchantResourceWallet>;
    public apiMerchantResourceWalletGet(merchantResourceWalletId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MerchantResourceWallet>>;
    public apiMerchantResourceWalletGet(merchantResourceWalletId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MerchantResourceWallet>>;
    public apiMerchantResourceWalletGet(merchantResourceWalletId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantResourceWalletId !== undefined && merchantResourceWalletId !== null) {
            queryParameters = queryParameters.set('merchantResourceWalletId', <any>merchantResourceWalletId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MerchantResourceWallet>('get',`${this.basePath}/api/MerchantResourceWallet`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param merchantWalletId 
     * @param resourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantResourceWalletGetByClientResourceIdAndWalletIdGet(merchantWalletId?: string, resourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<MerchantResourceWallet>;
    public apiMerchantResourceWalletGetByClientResourceIdAndWalletIdGet(merchantWalletId?: string, resourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MerchantResourceWallet>>;
    public apiMerchantResourceWalletGetByClientResourceIdAndWalletIdGet(merchantWalletId?: string, resourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MerchantResourceWallet>>;
    public apiMerchantResourceWalletGetByClientResourceIdAndWalletIdGet(merchantWalletId?: string, resourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantWalletId !== undefined && merchantWalletId !== null) {
            queryParameters = queryParameters.set('merchantWalletId', <any>merchantWalletId);
        }
        if (resourceId !== undefined && resourceId !== null) {
            queryParameters = queryParameters.set('resourceId', <any>resourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MerchantResourceWallet>('get',`${this.basePath}/api/MerchantResourceWallet/GetByClientResourceIdAndWalletId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantResourceWalletPost(body?: MerchantResourceWalletMapDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiMerchantResourceWalletPost(body?: MerchantResourceWalletMapDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiMerchantResourceWalletPost(body?: MerchantResourceWalletMapDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiMerchantResourceWalletPost(body?: MerchantResourceWalletMapDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/MerchantResourceWallet`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param resourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMerchantResourceWalletResourceIdGet(resourceId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<MerchantResourceWallet>>;
    public apiMerchantResourceWalletResourceIdGet(resourceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MerchantResourceWallet>>>;
    public apiMerchantResourceWalletResourceIdGet(resourceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MerchantResourceWallet>>>;
    public apiMerchantResourceWalletResourceIdGet(resourceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (resourceId === null || resourceId === undefined) {
            throw new Error('Required parameter resourceId was null or undefined when calling apiMerchantResourceWalletResourceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MerchantResourceWallet>>('get',`${this.basePath}/api/MerchantResourceWallet/${encodeURIComponent(String(resourceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
